<template>
  <div class="financials_companies">
    <div class="financials_container clearfix">
      <slot name="info"></slot>
    </div>

    <!-- IPO -->
    <div class="IPO downContainer">
      <el-button
        type="text"
        v-if="allKey.COMPANY_DOWNLOAD"
        class="downLoadBtn paddingBtn"
        @click="downLoadFn(ipoData, Config.ipo,'IPO')"
      >
        <i class="el-icon-download"></i>
        download
      </el-button>
      <title-temp title="IPO"></title-temp>
      <table-list :column="Config.ipo" :tableData="ipoData" cls="double" :column200="true"></table-list>
    </div>

    <!-- Public Additional Offering -->
    <div class="public_additional_offering downContainer">
      <el-button
        type="text"
        class="downLoadBtn paddingBtn"
        v-if="allKey.COMPANY_DOWNLOAD"
        @click="downLoadFn(publicData, Config.publicData,'Public Additional Offering')"
      >
        <i class="el-icon-download"></i>
        download
      </el-button>
      <title-temp title="Public Additional Offering"></title-temp>
      <table-list
        :column="Config.publicData"
        :tableData="publicData"
        cls="double"
        :column200="true"
      ></table-list>
    </div>

    <!-- Non-Public Additional Offering -->
    <div class="Non-Public_additional_offering downContainer">
      <el-button
        type="text"
        class="downLoadBtn paddingBtn"
        v-if="allKey.COMPANY_DOWNLOAD"
        @click="downLoadFn(NonPublicData, Config.NonPublicData,'Non-Public Additional Offering')"
      >
        <i class="el-icon-download"></i>
        download
      </el-button>
      <title-temp title="Non-Public Additional Offering"></title-temp>
      <table-list
        :column="Config.NonPublicData"
        :tableData="NonPublicData"
        cls="double"
        :column200="true"
      ></table-list>
    </div>

    <!-- Rights Issue -->
    <div class="rights_Issue downContainer">
      <el-button
        type="text"
        class="downLoadBtn paddingBtn"
        v-if="allKey.COMPANY_DOWNLOAD"
        @click="downLoadFn(rightsIssueData, Config.rightsIssue,'Rights Issue')"
      >
        <i class="el-icon-download"></i>
        download
      </el-button>
      <title-temp title="Rights Issue"></title-temp>
      <table-list
        :column="Config.rightsIssue"
        :tableData="rightsIssueData"
        cls="double"
        :column200="true"
      ></table-list>
    </div>

    <!-- Cash flow statement（非美国） 移入financials模块-->
    <!-- <div class="cash_flow">
      <title-temp title="Cash flow statement（ un-American ）"></title-temp>
      <el-select v-model="cashFlowQuarter" placeholder="请选择季度" class="qurarter_cls">
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="third_module">
        <p class="module_title">
          Operating cash flows
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.operatingCashFlow"
          :tableData="operatingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Investing cash flows
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.investingCashFlow"
          :tableData="investingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Financing cash flows
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.financingCashFlow"
          :tableData="financingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Balance
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.balance"
          :tableData="balanceData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>
    </div>-->

    <!-- Cash flow statement（美国） 暂时删除-->
    <!-- <div class="cash_flow">
      <title-temp title="Cash flow statement（美国）"></title-temp>
      <el-select v-model="AcashFlowQuarter" placeholder="请选择季度" class="qurarter_cls">
        <el-option
          v-for="item in quarterOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <div class="third_module">
        <p class="module_title">
          Operating cash flows
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.AoperatingCashFlow"
          :tableData="AoperatingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Investing cash flows
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.AinvestingCashFlow"
          :tableData="AinvestingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Financing cash flows
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.AfinancingCashFlow"
          :tableData="AfinancingCashFlowData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Balance
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.Abalance"
          :tableData="AbalanceData"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>

      <div class="third_module">
        <p class="module_title">
          Supplementals
          <span class="unit">(Exchange rate: CNY/USD):</span>
        </p>
        <table-form
          :columnData="Config.Asupplementals"
          :tableData="Asupplementals"
          largeLabelCls="largeLabel"
        ></table-form>
      </div>
    </div>-->
  </div>
</template>

<script>
import TitleTemp from "common/components/Title";
import TableForm from "common/components/tableForm";
import TableList from "common/components/table";
import Quarter from "conf/Quarter";

import Config from "conf/FinCompanies";

import { getCompanyFinancialListed, getBasic } from "common/js/http/v2Api";
import { mapState, mapMutations } from "vuex";

export default {
  components: {
    TitleTemp,
    TableForm,
    TableList
  },

  data() {
    return {
      Config,
      id: this.$route.query.id,
      code: this.$route.query.code,
      quarterOptions: Quarter,
      // ipo
      ipoData: [],

      //publicData
      publicData: [],

      // NonPublicData
      NonPublicData: [],

      // rightsIssueData
      rightsIssueData: []

      //cashFlow 非美国
      // cashFlowQuarter: 1,
      // operatingCashFlowData: {},
      // investingCashFlowData: {},
      // financingCashFlowData: {},
      // balanceData: {},

      //AcashFlow 非美国
      // AcashFlowQuarter: 1,
      // AoperatingCashFlowData: {
      //   year: ["2019", "2018", "2017"],
      //   a: [
      //     "employeesemployeesemployeesemployeesemployees",
      //     "employees",
      //     "employees"
      //   ]
      // },
      // AinvestingCashFlowData: {
      //   year: ["2019", "2018", "2017"],
      //   a: [
      //     "employeesemployeesemployeesemployeesemployees",
      //     "employees",
      //     "employees"
      //   ]
      // },
      // AfinancingCashFlowData: {},
      // AbalanceData: {},
      // Asupplementals: {}
    };
  },

  created() {
    this.getF10Id();
  },

  methods: {
    async getF10Id() {
      const { result } = await getBasic(this.id, this.code);
      const f10Id = result.f10Id;
      this.getListedData(f10Id);
    },

    async getListedData(id) {
      const { result } = await getCompanyFinancialListed(id);
      this.ipoData = [this.formatData(result.Ipo, Config.ipo)];
      this.publicData = [
        this.formatData(result["Public Additional Offering"], Config.publicData)
      ];
      this.NonPublicData = [
        this.formatData(
          result["Non-Public Additional Offering"],
          Config.NonPublicData
        )
      ];
      this.rightsIssueData = [
        this.formatData(result["Rights Issue"], Config.rightsIssue)
      ];
    },

    formatData(data, column) {
      // 数据为null
      if (!data || !Object.keys(data).length) {
        const result = {};
        column.forEach(item => {
          result[item.field] = "";
        });
        return result;
      }

      Object.keys(data).forEach(item => {
        if (!data[item] || data[item] == "null") {
          data[item] = "";
        }
      });
      return data;
    },

    downLoadFn(data, column, fileName) {
      let str = "";
      let strArr = [];
      let fieldArr = [];
      column.forEach(item => {
        strArr.push(item.label);
        fieldArr.push(item.field); //字段信息  与表头信息顺序相同
      });
      str = strArr.join(",") + `\n`; //先遍历得到表头信息

      data.forEach(item => {
        fieldArr.forEach(field => {
          str += `${item[field] + "\t"},`;
        });
        str += "\n";
      });

      //encodeURIComponent解决中文乱码
      let uri = "data:text/csv;charset=utf-8,\ufeff" + encodeURIComponent(str);
      //通过创建a标签实现
      var link = document.createElement("a");
      link.href = uri;
      //对下载的文件命名
      link.download = `${fileName}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  computed: {
    ...mapState({
      allKey(state) {
        return state.v2Permission.v2CurrentPermission;
      }
    })
  }
};
</script>

<style scoped>
.third_module {
  padding: 10px;
  border: 1px solid #dee2e65c;
  margin-bottom: 10px;
}

.module_title {
  font-size: 16px;
  margin-bottom: 10px;
}
.module_title .unit {
  font-size: 14px;
}
.downContainer {
  position: relative;
}
.downLoadBtn {
  position: absolute;
  right: 0px;
  /* padding: 0px 20px !important; */
  top: 10px;
}
</style>